export default "__VITE_ASSET__xUet_O4Q__"